
import { Validator } from "../../../TOOLS/Validator";
import { FormController } from "./FormController";

export class NewInventoryForm {

    constructor(store) {
        this.store = store;
        this.validator = new Validator(this.store);
        this.formController = new FormController(this.store, this.validator);
        this.container = document.createElement("div");
        this.container.className = 'sectionColumn';
        this.container.id = 'NEWINVENTORYFORM MAIN';
        this.formObject = this.store.level.selectedDevice ?? {category: "", firestoreid: "", imei: "", brand: "", userid: null, leltar: "2026", barcode: "", id: 0, officeid: 0, ws: "", sn: "", type: "", model: "", comment: ""}
        this.excludedFields = [];
        this.keyChange = {
            category: "Kategória",
            brand: "Megnevezés",
            barcode: "Vonalkód",
            sn: "Szériaszám",
            model: "típus",
            comment: "Megjegyzés"
        };
        this.officeRolldown = [];
        this.categoryRolldown = [];
        this.brandRolldown = [];
        this.categorySelect = null;
        this.brandSelect = null;
        this.selectedOffice = null;
    }

    async render(caller) {
        console.log('caller', caller)
        this.caller = caller;
        //FORMMEZŐK KIZÁRÁSA
        if (this.caller === "Új eszköz") {
                this.excludedFields = ["id", "firestoreid", "districtid", "userid", "officeid", "leltar", "type"];
            } else { // Új bútor
                this.excludedFields = ["id", "firestoreid", "districtid", "userid", "leltar", "type"];
            }

        if(caller === 'Új bútor'){
            await this.store.datas.load('CITIES')
            let cities = this.store.database.cities.filter((city => city.district === this.store.level.selectedOffice.district));
            await this.buildRolldowns(cities)
        }else{await this.buildRolldowns()}
        this.container.innerHTML = "";
        const headerWrapper = document.createElement("div");
        headerWrapper.className = "wrapper width-100 row border-bottom margin-bottom-1 padding-left-1 padding-right-1 padding-top-2 padding-bottom-2";
        headerWrapper.id = 'HEADWRAPPER'
        const title = document.createElement("div");
        title.className = "font-30 weight-600 color-50";
        title.textContent = "ÚJ ESZKÖZ";
        headerWrapper.appendChild(title);
        this.container.appendChild(headerWrapper);
        this.container.appendChild(this.renderForm());
        return this.container;
    }

    renderForm() {
        const form = document.createElement("form");
        form.className = "width-100 height-100 column align-center overflow-y";
        form.id = 'FORMWRAPPER'
        
        
        Object.entries(this.formObject)
        .filter(([key]) => {
            if (this.excludedFields.includes(key)) {return false;}
            if (this.caller === "Új bútor" && key === "category") return false;
            return true;
        })
        .forEach(([key, value]) => {
            const row = document.createElement("div");
            row.className = "list-row";
            const label = document.createElement("label");
            label.textContent = this.keyChange[key] ?? key;
            row.appendChild(label);
            let field;
            if (key === "category" && this.caller === "Új eszköz") {
                field = document.createElement("select");
                field.className = 'form-input'
                field.name = key;
                this.categoryRolldown.forEach(item => {
                    const option = document.createElement("option");
                    option.value = item.value;
                    option.textContent = item.value;
                    if (item.value === value) option.selected = true;
                    field.appendChild(option);
                });
                this.categorySelect = field;
            } else if (key === "brand") {
                field = document.createElement("select");
                field.className = 'form-input'
                field.name = key;
                this.brandSelect = field;
                this.brandRolldown.forEach(item => {
                    const option = document.createElement("option");
                    option.value = item.value;
                    option.textContent = item.value;
                    if (item.value === value) option.selected = true;
                    field.appendChild(option);
                });
            } else if (key === "officeid") {
                field = document.createElement("select");
                field.className = 'form-input'
                field.name = key;
                field.addEventListener("change", () => {this.selectedOffice = Number(field.value);});
                this.officeRolldown.forEach(office => {
                    const option = document.createElement("option");
                    option.value = office.officeid;
                    option.textContent = office.name;
                    if (office.officeid === value) {
                        option.selected = true;
                        this.selectedOffice = office.officeid;
                    }
                    field.appendChild(option);
                });
            } else {
                field = document.createElement("input");
                field.className = 'form-input'
                field.name = key;
                field.type = typeof value === "number" ? "number" : "text";
                field.value = value ?? "";
            }
            row.appendChild(field);
            form.appendChild(row);
            if (this.categorySelect && this.brandSelect) {
                this.categorySelect.addEventListener("change", () => {this.updateBrandDropdown(this.categorySelect.value, this.brandSelect);});
                // ha már van kiválasztott kategória
                if (this.categorySelect.value && this.categorySelect.value !== "válassz!") {this.updateBrandDropdown(this.categorySelect.value, this.brandSelect);}
            }
        });

        const button = document.createElement("div");
        button.className = 'width-100 justify-center margin-top-2 login-button'
        button.type = "submit";
        this.bindItemEvents(button, form);
        button.style.flexShrink = "0";
        form.appendChild(button);
        return form
    }

    bindItemEvents(button, form) {
        button.addEventListener("click", async (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.formController.bindSubmit(form, {
            getData: this.getData.bind(this),
            complete: this.complete.bind(this),
            process: "SAVE",
            formType: this.store.level.formType,
            original: this.store.level.selectedDevice === null ? this.getData(form) : this.store.level.selectedDevice,
            reference: "INVENTORY",
            logtype: "SAVE",
                onSuccess: async (response) => {
                    this.store.levelController.setLevel({name: "MAP", office: null, position: null});
                    this.store.toast.success(response.message);
                }
            });
            form.requestSubmit();
        });
    }

    async buildRolldowns(cities = []) {
        if(this.caller === 'Új bútor'){
            const furnitures = await this.store.datas.filter('INVENTORY', 'type', 'FURNITURE')
            this.brandRolldown = [...new Set(furnitures.map(item => item.model))].map(model => ({key: model, value: model}));
            this.brandRolldown.unshift({key: 'válassz!', value: 'válassz!'})
            this.officeRolldown = await this.store.datas.getOfficeRolldownByDistrict(this.store.level.selectedDistrict)
 
        }else if(this.caller === 'Új eszköz'){
            const devices = await this.store.datas.filter('INVENTORY', 'type', 'IT')
            this.categoryRolldown = [...new Set(devices.map(item => item.category))].map(category => ({key: category, value: category}));
            this.categoryRolldown.unshift({key: 'válassz!', value: 'válassz!'})
            this.brandRolldown = [{ key: "válassz!", value: "válassz!" }];
        }
    }

    getData(form) {
        const result = { ...this.formObject };
        Array.from(form.elements).forEach(element => {
            if (!element.name) return;
            if (element.name === "job") {result.job = element.checked ? "HO" : "FG";
            }else if (element.name === "officeid") {result.officeid = Number(element.value);
            }else {result[element.name] = element.type === "number" ? Number(element.value) : element.value;}
        });
        return result;
    }


    async complete(data) {
        if(this.caller === 'Új bútor'){
            data.type = 'FURNITURE'
        }
        if(this.caller === 'Új eszköz'){
            data.userid = this.store.level.selectedColleague.id;
            data.officeid = this.store.level.selectedColleague.officeid
            data.type = 'IT';
        }
        return data    
    }

    updateBrandDropdown(category, brandSelect) {
        brandSelect.innerHTML = "";
        const brands = [...new Set(this.store.database.inventory.filter(item => item.category === category).map(item => item.brand))];
        const first = document.createElement("option");
        first.value = "";
        first.textContent = "válassz!";
        brandSelect.appendChild(first);
        brands.forEach(brand => {
            const option = document.createElement("option");
            option.value = brand;
            option.textContent = brand;
            brandSelect.appendChild(option);
        });
    }

}